// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bc807c8c","453":"5614e397","644":"24b5601d","667":"9af15be4"}[chunkId] + ".chunk.js";
};